import { render, staticRenderFns } from "./BasePaginationV2.vue?vue&type=template&id=4477da86"
import script from "./BasePaginationV2.vue?vue&type=script&lang=js"
export * from "./BasePaginationV2.vue?vue&type=script&lang=js"
import style0 from "./BasePaginationV2.vue?vue&type=style&index=0&id=4477da86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports